import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AxiosError } from 'axios';
import { RootState } from 'interfaces';
import { USER_OPERATIONS } from 'helper';
import useError from 'components/ErrorProvider/useError';
import { ITenantNotification } from '../interfaces';
import { getTenantNotification } from '../api';

export function useGetTenantNotification() {
  const operations = useSelector((state: RootState) => state.operations);

  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ITenantNotification | null>(null);

  const { addError } = useError();

  const getNotification = async () => {
    if (!operations.includes(USER_OPERATIONS.ROOM_TENANT)) return;

    setLoading(true);

    try {
      const response = await getTenantNotification();

      if (!response) return;

      setOpened(true);
      setData(response);
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  function handleCloseModal() {
    setOpened(false);
  }

  useEffect(() => {
    getNotification();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { opened, loading, data, handleCloseModal, getNotification };
}
